var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.58991 0.57733C7.91534 0.902766 7.91534 1.4304 7.58991 1.75584L3.17916 6.16658H12.834C13.2942 6.16658 13.6673 6.53968 13.6673 6.99992C13.6673 7.46016 13.2942 7.83325 12.834 7.83325H3.17916L7.58991 12.244C7.91534 12.5694 7.91534 13.0971 7.58991 13.4225C7.26447 13.7479 6.73683 13.7479 6.4114 13.4225L0.578062 7.58917C0.252625 7.26374 0.252625 6.7361 0.578062 6.41066L6.4114 0.57733C6.73683 0.251893 7.26447 0.251893 7.58991 0.57733Z",
    fill: "#818181"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.ab116214ca2993d7a369b5eb39e782ee.svg";
export { ForwardRef as ReactComponent };